// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\[id\\]_breadcrumb__UEOSG {
  font-size: 0.75rem;
}

@media screen and (min-width: 48em) {
  .\\[id\\]_breadcrumb__UEOSG {
    font-size: 0.875rem;
  }
}
.\\[id\\]_scrollContainer__fSrk8,
.\\[id\\]_scrollSection__6Dmms {
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100dvh - 6.5rem);
}
@media screen and (min-width: 48em) {
  .\\[id\\]_scrollContainer__fSrk8,
  .\\[id\\]_scrollSection__6Dmms {
    height: calc(100vh - 7.8rem);
  }
}
@media screen and (min-width: 62em) {
  .\\[id\\]_scrollContainer__fSrk8,
  .\\[id\\]_scrollSection__6Dmms {
    overflow-y: scroll;
    height: calc(100vh - 8.8rem);
  }
}

@media screen and (min-width: 75em) {
  .\\[id\\]_scrollContainer__fSrk8 {
    overflow: hidden;
  }
}

.\\[id\\]_scrollSection__6Dmms {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.\\[id\\]_scrollContainer__fSrk8::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/%5Bid%5D/index.module.scss","webpack://./src/pages/reporting/[id]/index.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;;ADEA;EACE;IACE,mBAAA;ECCF;AACF;ADEA;;EAEE,kBAAA;EACA,kBAAA;EACA,6BAAA;ACAF;ADEE;EANF;;IAOI,4BAAA;ECEF;AACF;ADAE;EAVF;;IAWI,kBAAA;IACA,4BAAA;ECIF;AACF;;ADAE;EADF;IAEI,gBAAA;ECIF;AACF;;ADDA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;ACIF;;ADDA;EACE,aAAA;ACIF","sourcesContent":[".breadcrumb {\n  font-size: 0.75rem;\n}\n\n@media screen and (min-width: 48em) {\n  .breadcrumb {\n    font-size: 0.875rem;\n  }\n}\n\n.scrollContainer,\n.scrollSection {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: calc(100dvh - 6.5rem);\n\n  @media screen and (min-width: 48em) {\n    height: calc(100vh - 7.8rem);\n  }\n\n  @media screen and (min-width: 62em) {\n    overflow-y: scroll;\n    height: calc(100vh - 8.8rem);\n  }\n}\n\n.scrollContainer {\n  @media screen and (min-width: 75em) {\n    overflow: hidden;\n  }\n}\n\n.scrollSection {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.scrollContainer::-webkit-scrollbar {\n  display: none;\n}\n",".breadcrumb {\n  font-size: 0.75rem;\n}\n\n@media screen and (min-width: 48em) {\n  .breadcrumb {\n    font-size: 0.875rem;\n  }\n}\n.scrollContainer,\n.scrollSection {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: calc(100dvh - 6.5rem);\n}\n@media screen and (min-width: 48em) {\n  .scrollContainer,\n  .scrollSection {\n    height: calc(100vh - 7.8rem);\n  }\n}\n@media screen and (min-width: 62em) {\n  .scrollContainer,\n  .scrollSection {\n    overflow-y: scroll;\n    height: calc(100vh - 8.8rem);\n  }\n}\n\n@media screen and (min-width: 75em) {\n  .scrollContainer {\n    overflow: hidden;\n  }\n}\n\n.scrollSection {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.scrollContainer::-webkit-scrollbar {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumb": `[id]_breadcrumb__UEOSG`,
	"scrollContainer": `[id]_scrollContainer__fSrk8`,
	"scrollSection": `[id]_scrollSection__6Dmms`
};
export default ___CSS_LOADER_EXPORT___;
